// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__R1CDb"};